// extracted by mini-css-extract-plugin
module.exports = {"welcome-page-container":"styles_welcome-page-container__3Zutj"};